<template>
  <form @submit.prevent="submit()">
    <v-card>
      <v-card-title>{{ $t('invitationform.title') }}</v-card-title>
      <v-card-text>
        <p>{{ $t('invitationform.text') }}</p>
        <text-input v-model="email" :config="{
          type: 'email',
          required: true,
          label: $t('invitationform.labels.email'),
          errors: (error.email || []).map(e => () => e)
        }"></text-input>
        <text-input v-model="password" :config="{
          type: 'password',
          label: $t('invitationform.labels.password'),
          hint: $t('invitationform.hints.password'),
          persistentHint: true,
          errors: (error.password || []).map(e => () => e)
        }"></text-input>
        
      </v-card-text>
      <v-card-row actions>
        <v-btn
          type="submit"
          primary light ripple
          :loading="loading">
          {{ $t('invitationform.submit') }}
        </v-btn>
      </v-card-row>
    </v-card>
  </form>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { TextInput } from '@/components/inputs'
  export default {
    components: {
      TextInput
    },
    data () {
      return {
        email: '',
        password: '',
        error: {}
      }
    },
    computed: mapGetters({
      loading: 'skiliko/experts/isLoading'
    }),
    methods: {
      ...mapActions({
        invite: 'skiliko/experts/invite'
      }),
      submit () {
        this.invite({ email: this.email, password: this.password })
          .then(expert => this.$emit('invited', expert))
          .catch(({ response }) => (this.error = (response || {}).data || {}))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/InvitationForm.vue